export const loadCaseOrCheckResultOverCapacity = (capacity: number) => capacity > 1;
